module.exports = require('./helpers/bundle-url').getBundleURL('kuLgW') + "workers.411b1a1d.js";